import React from 'react';
import { FormLayoutProps } from 'ui-builder';
import DefaultPopupFormLayout from './NotCenteredPopupFormLayout';

export default function CenteredPopupFormLayout(props: FormLayoutProps) {
  /* eslint-disable react/jsx-props-no-spreading */
  return (
    <DefaultPopupFormLayout
      {...props}
      isCentered
    />
  );
}
